import { AssetTransformer } from "@/transformers/asset.transformer";
import { CodeTransformer } from "@/transformers/code.transformer";
import { ConfigTransformer } from "@/transformers/config.transformer";
import { ContractTransformer } from "@/transformers/contract.transformer";
import { FileTransformer } from "@/transformers/file.transformer";
import { LogTransformer } from "@/transformers/log.transformer";
import { FirmTransformer } from "@/transformers/firm.transformer";
import { MissionTransformer } from "@/transformers/mission.transformer";
import { MissionAssetTransformer } from "@/transformers/missionAsset.transformer";
import { UserTransformer } from "@/transformers/user.transformer";
import { CommentTransformer } from "@/transformers/comment.transformer";

const transformers = {
  assets: AssetTransformer,
  codes: CodeTransformer,
  config: ConfigTransformer,
  configs: ConfigTransformer,
  file: FileTransformer,
  files: FileTransformer,
  log: LogTransformer,
  logs: LogTransformer,
  firm: FirmTransformer,
  firms: FirmTransformer,
  mission: MissionTransformer,
  missions: MissionTransformer,
  "mission-last-serviced": MissionTransformer,
  "mission-asset": MissionAssetTransformer,
  "mission-assets": MissionAssetTransformer,
  "mission-assets-cleaned": MissionAssetTransformer,
  "mission-assets-fault": MissionAssetTransformer,
  user: UserTransformer,
  users: UserTransformer,
  contract: ContractTransformer,
  comment: CommentTransformer,
  comments: CommentTransformer,
};

function getArrayData(data) {
  return Array.isArray(data) ? data : [data];
}

function transform(data, included) {
  return data.map((obj) => {
    const transformed =
      obj.type && transformers[obj.type]
        ? transformers[obj.type].transform(obj)
        : obj;
    const relationships = obj.relationships || {};

    Object.keys(relationships).forEach((key) => {
      let relationshipData = getArrayData(relationships[key].data);
      relationshipData = relationshipData.map((relationship) =>
        included.find(
          (include) =>
            include.type === relationship.type && include.id === relationship.id
        )
      );

      const relationshipTransformed = transform(relationshipData, included);

      // Attach to relationship data to main object
      transformed[key] = Array.isArray(relationships[key].data)
        ? relationshipTransformed
        : relationshipTransformed.shift();
    });

    return transformed;
  });
}

export function denormalize(response) {
  const data = getArrayData(response.data);
  const included = response.included || [];
  const transformed = transform(data, included);

  return Array.isArray(response.data) ? transformed : transformed.shift();
}
